import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Build Requirements',
      type: 'table',
      content: {
        '{}': {
          count: {
            '`': {
              selection: {
                '#': {
                  '@': 'requirements',
                },
              },
              subqueries: {
                requirements: {
                  filter: {
                    and: [
                      {
                        or: [
                          {
                            '=': [
                              { '`': { '``': { '@$': 'projectId' } } },
                              null,
                            ],
                          },
                          {
                            '=': [
                              { '@': 'specProject' },
                              {
                                '@>': [
                                  { '`': { '``': { '@$': 'projectId' } } },
                                  'recordId',
                                ],
                              },
                            ],
                          },
                        ],
                      },
                      {
                        '!=': [
                          {
                            '@': 'specApprovedAt',
                          },
                          null,
                        ],
                      },
                      {
                        '=': [
                          {
                            '@': 'buildLinks',
                          },
                          null,
                        ],
                      },
                    ],
                  },
                  target: 'ent:!requirements:!requirement',
                  selection: {
                    '@.': '!id',
                  },
                  subqueries: {
                    specProject: {
                      ref: {
                        attr: 'attr:ent#!requirements#!requirement:!spec',
                      },
                      target: 'ent:!specs:!spec',
                      selection: {
                        '@.': ['!project', { ref: { entity: '!proj' } }],
                      },
                    },
                    buildLinks: {
                      ref: {
                        attr: 'attr:ent#!pr_req_links#!pr_req_link:!requirement',
                      },
                      target: 'ent:!pr_req_links:!pr_req_link',
                      selection: {
                        '@.': '!id',
                      },
                    },
                    specApprovedAt: {
                      ref: {
                        attr: 'attr:ent#!requirements#!requirement:!spec',
                      },
                      target: 'ent:!specs:!spec',
                      quantity: 1,
                      selection: {
                        '@': 'approvalMergedAt',
                      },
                      subqueries: {
                        approvalMergedAt: {
                          ref: {
                            attr: 'attr:ent#!specs#!spec:!approval_pull_request',
                          },
                          target: 'ent:!pull_requests:!pull_request',
                          selection: {
                            '@.': '!merged_at',
                          },
                        },
                      },
                    },
                  },
                },
              },
            },
          },
          query: {
            '`': {
              sort: {
                by: {
                  '@.': '!id',
                },
              },
              filter: {
                and: [
                  {
                    or: [
                      { '=': [{ '`': { '``': { '@$': 'projectId' } } }, null] },
                      {
                        '=': [
                          { '@': 'specProject' },
                          {
                            '@>': [
                              { '`': { '``': { '@$': 'projectId' } } },
                              'recordId',
                            ],
                          },
                        ],
                      },
                    ],
                  },
                  {
                    '!=': [
                      {
                        '@': 'specApprovedAt',
                      },
                      null,
                    ],
                  },
                  {
                    '=': [
                      {
                        '@': 'buildLinks',
                      },
                      null,
                    ],
                  },
                ],
              },
              target: 'ent:!requirements:!requirement',
              selection: {
                '{}': {
                  fields: {
                    '{}': {
                      assertion: {
                        '{}': {
                          value: {
                            '@.': '!name',
                          },
                        },
                      },
                      decidedFrom: {
                        '{}': {
                          value: {
                            '++': [
                              'commit ',
                              {
                                '@.': '!commit_sha',
                              },
                            ],
                          },
                        },
                      },
                      requirement: {
                        '{}': {
                          value: {
                            '@.': '!id',
                          },
                        },
                      },
                      developmentState: {
                        '{}': {
                          value: {
                            '??': [
                              {
                                '@.': '!status',
                              },
                              'Not To Do',
                            ],
                          },
                        },
                      },
                    },
                  },
                  onClick: {
                    '{}': {
                      action: {
                        '{}': {
                          payload: {
                            '{}': {
                              agentId: 'workPacketGenerator',
                              records: {
                                '[]': [
                                  {
                                    '{}': {
                                      modelId: 'ent:!specs:!spec',
                                      recordId: {
                                        '@': 'specId',
                                      },
                                    },
                                  },
                                ],
                              },
                            },
                          },
                          operation: 'ui.open-assistant',
                        },
                      },
                      variables: {
                        '{}': {
                          reqId: {
                            '@': 'specId',
                          },
                        },
                      },
                    },
                  },
                },
              },
              subqueries: {
                specProject: {
                  ref: { attr: 'attr:ent#!requirements#!requirement:!spec' },
                  target: 'ent:!specs:!spec',
                  selection: {
                    '@.': ['!project', { ref: { entity: '!proj' } }],
                  },
                },
                specId: {
                  ref: {
                    attr: 'attr:ent#!requirements#!requirement:!spec',
                  },
                  target: 'ent:!specs:!spec',
                  quantity: 1,
                  selection: {
                    '@.': '!id',
                  },
                },
                buildLinks: {
                  ref: {
                    attr: 'attr:ent#!pr_req_links#!pr_req_link:!requirement',
                  },
                  target: 'ent:!pr_req_links:!pr_req_link',
                  selection: {
                    '@.': '!id',
                  },
                },
                specApprovedAt: {
                  ref: {
                    attr: 'attr:ent#!requirements#!requirement:!spec',
                  },
                  target: 'ent:!specs:!spec',
                  quantity: 1,
                  selection: {
                    '@': 'approvalMergedAt',
                  },
                  subqueries: {
                    approvalMergedAt: {
                      ref: {
                        attr: 'attr:ent#!specs#!spec:!approval_pull_request',
                      },
                      target: 'ent:!pull_requests:!pull_request',
                      selection: {
                        '@.': '!merged_at',
                      },
                    },
                  },
                },
              },
            },
          },
          columns: {
            '[]': [
              {
                '{}': {
                  id: 'requirement',
                  direct: {
                    '{}': {
                      name: 'Requirement',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'assertion',
                  direct: {
                    '{}': {
                      name: 'Assertion',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'developmentState',
                  direct: {
                    '{}': {
                      name: 'Development State',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'decidedFrom',
                  direct: {
                    '{}': {
                      name: 'Decided From',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
            ],
          },
        },
      },
    },
  },
}
